import { motion } from "framer-motion";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

import { ANIMATION_DURATION } from "@/constants/animations.constants";
import { MobileViewportContainer } from "@/modules/onboarding/components/MobileViewportContainer/MobileViewportContainer";
import { OnboardingBackButton } from "@/modules/onboarding/components/OnboardingBackButton/OnboardingBackButton";
import {
  NameForm,
  type NameFormData,
} from "@/modules/onboarding/forms/NameForm/NameForm";
import { updateUserIfAuthenticated } from "@/modules/onboarding/utils/updateUserIfAuthenticated";
import { useUser } from "@/modules/user/useUser/useUser";

const V3NamePage = () => {
  const navigate = useNavigate();
  const { user } = useUser();
  const initialFirstName = user?.firstName ?? "";
  const initialLastName = user?.lastName ?? "";
  const platformIdFromStorage = localStorage.getItem("platformId");
  const platformId = platformIdFromStorage || (user?.platform?.id ?? "");
  const backToLocationPath = `/signin/location?platformId=${platformId}`;

  const handleSubmit = useCallback(
    async (data: NameFormData) => {
      await updateUserIfAuthenticated({
        firstName: data.firstName,
        lastName: data.lastName,
      });
      navigate("/signin/email");
    },
    [navigate]
  );

  return (
    <MobileViewportContainer
      header={<OnboardingBackButton prev={backToLocationPath} />}
    >
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: ANIMATION_DURATION, delay: 0.1 }}
        className="flex w-full max-w-sm flex-col items-center gap-9"
      >
        <NameForm
          key={`name-${initialFirstName}-${initialLastName}`}
          initialFirstName={initialFirstName}
          initialLastName={initialLastName}
          onSubmit={handleSubmit}
          submitButtonText="Confirm"
        />
      </motion.div>
    </MobileViewportContainer>
  );
};

export default V3NamePage;
